import React, { useEffect, useState, useCallback } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { GetAdminList } from "../../Redux/Actions/adminActions";
import toast from "react-hot-toast";
import { columnsAdmins } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListAdmins = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    async (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && {
          start_date: dateRange.start.format("YYYY-MM-DD"),
        }),
        ...(dateRange.end && {
          end_date: dateRange.end.format("YYYY-MM-DD"),
        }),
      };

      try {
        await dispatch(GetAdminList(payload, showLoader));
        if (!showLoader) {
          toast.success("Admins list refreshed");
        }
      } catch {
        if (!showLoader) {
          toast.error("Failed to refresh admins list");
        }
      }
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [
    pagination.current,
    pagination.pageSize,
    fetchDetails,
  ]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);


  const { list } = useSelector((state) => state.adminList || {});
  const { loading } = useSelector((state) => state.adminList);

  useEffect(() => {
    if (list?.total) {
      setPagination((prevData) => ({ ...prevData, total: list.total }));
    }
  }, [list]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        h3heading="Admins List"
        columns={columnsAdmins}
        // onChange={handleTableChange}
        buttonhead2="Add Admin"
        pagination={pagination}
        onChange={handleTableChange}
        dataSource={Array.isArray(list?.data) ? list.data : []}
        navigateTo2="/manage_admins/add"
        setState={setSearchQuery}
        loading={loading}
        onCalendarClick={() => setIsDatePopupVisible(true)}
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListAdmins;
